import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[72vh] w-full items-center justify-center bg-background-50 px-4 pb-16 pt-28">
      <div className="w-full max-w-lg rounded-lg border border-background-200 bg-background-100/60 px-6 py-14 text-center">
        <p className="font-heading text-5xl font-bold text-background-300">404</p>
        <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          你访问的路径 <span className="font-label text-foreground-800">{location.pathname}</span> 暂无对应内容。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Link
            to="/"
            className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-700"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </div>
  );
}